import localStorageUtil from '@/common/utils/localStorageUtil';
import Utils from '@/common/utils/utils';
import {
    getFieldListByCorporation,
    getFormListGlobalStateAtom
} from '@/service/formManagementService';
import API from '@/amplify/api';
import { cloneDeep } from 'lodash';
import { atom } from 'recoil';

export const listFormOfCorporationAtom = atom({
    key: 'listFormOfCorporationAtom',
    default: [],
    effects: [
        async ({ setSelf, onSet, trigger, getPromise, getLoadable }) => {
            try {
                let corporationId = localStorageUtil.getAffiliationOrganization();
                // get list form in corporation
                let listForm = await getFormListGlobalStateAtom(API, corporationId);
                setSelf(listForm);
            } catch (err) {
                console.log('listFormOfCorporationAtom err', err);
                setSelf([]);
            }
        }
    ]
});

export const fieldListOfCorporationAtom = atom({
    key: 'fieldListOfCorporationAtom',
    default: [],
    effects: [
        async ({ setSelf, onSet, trigger, getPromise, getLoadable }) => {
            let lastCorporationId = null;

            const fetchFieldList = async (corporationId) => {
                lastCorporationId = corporationId;

                try {
                    // get fieldList
                    let fieldList = await getFieldListByCorporation(API, corporationId,{from: 0, size: 200, isGetForList: true})
                    if (!Utils.isEmptyArray(fieldList)) {
                        fieldList.forEach(field => {
                            // convert order object string to object
                            field.order = JSON.parse(field.order);
                            field.usingForms = JSON.parse(field.usingForms);
                        });
                    }
                    let listFieldClone = [];
                    fieldList.forEach(field => {
                        let usingProjectsClone = [];
                        let usingProjects = field?.usingProjects;
                        if (!Utils.isEmptyArray(usingProjects)) {
                            usingProjects.forEach(text => {
                                for (var i = 0; i < text.length; i++) {
                                    let id;
                                    if (text.charAt(i) === '_') {
                                        if (i <= 7) {
                                            id = text.substring(0, 44);
                                        } else {
                                            let startIndex = i - 7;
                                            let end_index = i + 37;
                                            id = text.substring(startIndex, end_index);
                                        }
                                        
                                        if (
                                            id.length === 44 &&
                                            Utils.getPrefixOfId(id) === 'project' &&
                                            !usingProjectsClone.includes(id)
                                        ) {
                                            usingProjectsClone.push(id);
                                        }
                                    }
                                }
                            });
                        }
                        let formClone = cloneDeep(field);
                        formClone.usingProjects = usingProjectsClone;
                        listFieldClone.push(formClone);
                    });
                    setSelf(listFieldClone);
                } catch (err) {
                    console.log('fieldListOfCorporationAtom err', err);
                    setSelf([]);
                }

            }

            
            // Initial load
            let corporationId = localStorageUtil.getAffiliationOrganization();
            if (corporationId) {
                await fetchFieldList(corporationId);
            }

            // Listen for changes in localStorage
            const checkCorporationChange = () => {
                const currentCorporationId = localStorageUtil.getAffiliationOrganization();
                if (currentCorporationId !== lastCorporationId) {
                    if (currentCorporationId) {
                        fetchFieldList(currentCorporationId);
                    } else {
                        setSelf([]);
                        lastCorporationId = null;
                    }
                }
            };

            // Check for changes periodically
            const intervalId = setInterval(checkCorporationChange, 1000);

            // Cleanup
            return () => {
                clearInterval(intervalId);
            };
        }
    ]
});

export const formPanelTabCloseManagementAtom = atom({
    key: 'formPanelTabCloseManagementAtom',
    default: {
        isDirty: false,
        isClosePanel: false,
        isCloseScreen: false
    }
});
